export default [
  {
    path: "/event-manager",
    name: "event-management",
    meta: { title: "Event-Management" },
    component: () => import("../views/event/event-list.vue")
  }
]